import { ThemeEvents } from '@theme/events';

const GIFT_THRESHOLD = 9000; // $90.00 in cents
const SESSION_KEY = 'freeHatPopupShown';

function showPopup() {
  const popup = document.getElementById('free-hat-popup');
  if (!popup) return;
  popup.hidden = false;
  document.body.style.overflow = 'hidden';
}

function hidePopup() {
  const popup = document.getElementById('free-hat-popup');
  if (!popup) return;
  popup.hidden = true;
  document.body.style.overflow = '';
}

function maybeShow(totalPrice) {
  if (typeof totalPrice !== 'number') return;
  if (totalPrice >= GIFT_THRESHOLD && sessionStorage.getItem(SESSION_KEY) !== 'true') {
    showPopup();
    sessionStorage.setItem(SESSION_KEY, 'true');
  }
}

document.addEventListener(ThemeEvents.cartUpdate, (event) => {
  const cart = event.detail && event.detail.resource;
  if (cart && typeof cart.total_price === 'number') {
    maybeShow(cart.total_price);
  } else {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cartData) => maybeShow(cartData.total_price))
      .catch(() => {});
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const closeButton = document.getElementById('free-hat-popup-close');
  const backdrop = document.getElementById('free-hat-popup-backdrop');
  const ctaButton = document.getElementById('free-hat-popup-cta');

  closeButton?.addEventListener('click', hidePopup);
  backdrop?.addEventListener('click', hidePopup);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') hidePopup();
  });

  ctaButton?.addEventListener('click', () => {
    hidePopup();
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    } else {
      window.location.href = '/cart';
    }
  });
});
